import React, { useEffect, useRef } from 'react';

const ImpersonateFrame = ({ token }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (token && iframeRef.current) {
      // Criar URL da aplicação principal com o token
      const baseUrl = window.location.origin;
      const impersonateUrl = `${baseUrl}/impersonate?token=${token}`;
      
      // Definir src do iframe
      iframeRef.current.src = impersonateUrl;
    }
  }, [token]);

  return (
    <iframe
      ref={iframeRef}
      className="w-full h-full border-0 rounded-lg"
      title="Impersonificação de Usuário"
      sandbox="allow-same-origin allow-scripts allow-forms allow-navigation"
    />
  );
};

export default ImpersonateFrame; 